import api from './api.ts';

export interface ApiKeys {
    claude_api_key: string;
    gemini_api_key: string;
    openai_api_key: string;
    core_api_key: string;
    deepseek_api_key: string;
}

export interface QuickReviewReason {
    id: number;
    text: string;
    type: 'accept' | 'reject';
}

// Add a simple event system
type Listener = () => void;
const listeners: Listener[] = [];

export const optionsService = {
    async getApiKeys(): Promise<ApiKeys> {
        const response = await api.get('/options/api-keys');
        return response.data;
    },

    async updateApiKeys(apiKeys: ApiKeys): Promise<{ message: string }> {
        const response = await api.post('/options/api-keys', apiKeys);
        return response.data;
    },

    async getQuickReasons(): Promise<QuickReviewReason[]> {
        const response = await api.get('/options/quick-reasons');
        return response.data;
    },

    async createQuickReason(text: string, type: 'accept' | 'reject'): Promise<QuickReviewReason> {
        const response = await api.post('/options/quick-reasons', { text, type });
        // Notify listeners that quick reasons have changed
        this.notifyQuickReasonsChanged();
        return response.data;
    },

    async deleteQuickReason(id: number): Promise<{ message: string }> {
        const response = await api.delete(`/options/quick-reasons/${id}`);
        // Notify listeners that quick reasons have changed
        this.notifyQuickReasonsChanged();
        return response.data;
    },

    // Add methods for the event system
    addQuickReasonsListener(callback: Listener) {
        listeners.push(callback);
        return () => {
            const index = listeners.indexOf(callback);
            if (index !== -1) {
                listeners.splice(index, 1);
            }
        };
    },

    notifyQuickReasonsChanged() {
        listeners.forEach((listener) => listener());
    },
};
